<template>
  <b-modal
    @show="showStartSessionModal"
    @hidden="hideStartSessionModal"
    :static="true"
    id="startSessionModal"
    class="popover-modal"
    hide-header
    hide-footer
    no-close-on-esc
    scrollable
    ref="startSessionModal"
  >
    <div class="modal-details">
      <div class="d-flex title-con">
        <div class="d-flex modal-title-head" style="margin-inline: auto">
          <p style="text-align: center">
            {{ $t("emergencyList.form.startSession") }}
          </p>
          <svg
            v-if="!allSitesHaveActiveSession"
            @click="$bvModal.hide('startSessionModal')"
            width="22"
            height="22"
            viewBox="0 0 22 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="close-modal-btn"
          >
            <path
              d="M11 0C4.91333 0 0 4.91333 0 11C0 17.0867 4.91333 22 11 22C17.0867 22 22 17.0867 22 11C22 4.91333 17.0867 0 11 0ZM16.5978 14.7156C17.1111 15.2289 17.1111 16.06 16.5978 16.5733C16.3289 16.8422 16.0111 16.9644 15.6689 16.9644C15.3267 16.9644 14.9844 16.8422 14.74 16.5733L11.0733 12.9067L7.38222 16.5733C7.11333 16.8422 6.79556 16.9644 6.45333 16.9644C6.11111 16.9644 5.76889 16.8422 5.52444 16.5733C5.01111 16.06 5.01111 15.2289 5.52444 14.7156L9.21556 11.0244L5.52444 7.35778C5.01111 6.84444 5.01111 6.01333 5.52444 5.5C6.03778 4.98667 6.86889 4.98667 7.38222 5.5L11.0733 9.19111L14.7644 5.5C15.2778 4.98667 16.1089 4.98667 16.6222 5.5C17.1356 6.01333 17.1356 6.84444 16.6222 7.35778L12.9311 11.0489L16.5978 14.7156Z"
              fill="#F46A6A"
            ></path>
          </svg>
        </div>
      </div>
      <div v-if="allSitesHaveActiveSession" class="warningMsg">
        {{
          $t("emergencyList.form.allAreasAlreadyActiveInOtherSessionsMessage")
        }}
        <div class="inside-emergency-line"></div>
        <div
          class="actions-btn d-flex align-items-center justify-content-center"
        >
          <button
            class="single-okay"
            type="button"
            @click="$bvModal.hide('startSessionModal')"
          >
            {{ $t("common.okay") }}
          </button>
        </div>
      </div>

      <div v-else>
        <form-wizard
          class="custom-form-wizard form"
          ref="wizard"
          color="#103F5E"
          step-size="xs"
          @on-complete="onSubmit"
        >
          <!-- Step 1  -->
          <tab-content v-if="showTypeTab">
            <!-- <div class="form-group m-d-gruop emergency-type">
                <input maxlength="33" v-model="type" type="text" class="form-control" id="type" required />
                <label for="type">Emergency Type (Optional)</label>
              </div> -->
            <div class="emergency-input">
              <vp-input
                :label="$t('emergencyList.form.emergencyTypeOptional')"
                width="416"
                id="type"
                v-model="type"
                type="text"
                maxlength="20"
                :showRequiredAsterisk="false"
              />
            </div>
          </tab-content>

          <!-- step 2 -->
          <tab-content v-if="showSitesTab">
            <div class="sitesTreeview">
              <p class="sites-text-header">
                {{ $t("emergencyList.form.selectEmergencySiteAndArea") }}
              </p>
              <DxTreeView
                id="treeview"
                :ref="treeViewRef"
                width="100%"
                :height="450"
                :items="sitesOptions"
                :select-by-click="true"
                show-check-boxes-mode="selectAll"
                selection-mode="multiple"
                :select-nodes-recursive="true"
                @selection-changed="treeViewSelectionChanged"
                @content-ready="treeViewContentReady"
              >
                <template #item="item">
                  <div class="d-flex">
                    <span class="disabled-area">{{ item.data.label }}</span>
                    <span v-if="item.data.disabled" class="area-have-session">
                      <p v-if="item.data.isSite">
                        {{ $t("emergencyList.form.allAreasActiveInSessions") }}
                      </p>
                      <p v-else>(Active in a session)</p></span
                    >
                  </div>
                </template>
              </DxTreeView>
            </div>
          </tab-content>

          <!-- <div slot="footer" slot-scope="props">

              <div style="position: relative; bottom: 0">
                <div class="wizard-footer-left" :class="{ 'left-align': props.activeTabIndex > 0 }">
                  <wizard-button :disabled="props.activeTabIndex == 0" @click.native="previousTab()">Back</wizard-button>
                </div>

                <div class="wizard-footer-right">
                  <wizard-button :disabled="props.activeTabIndex == 1" @click.native="nextTab()">Next</wizard-button>
                </div>
                
              </div>
  
            </div> -->
          <div class="back-next-dots" slot="footer" slot-scope="props">
            <div style="position: relative; bottom: 0">
              <div class="right-left-position">
                <div
                  class="wizard-footer-left"
                  :class="{ 'left-align': props.activeTabIndex > 0 }"
                >
                  <wizard-button
                    :disabled="props.activeTabIndex == 0"
                    @click.native="previousTab()"
                    class="back-btn"
                    :style="props.fillButtonStyle"
                  >
                    {{ $t("common.back") }}
                  </wizard-button>
                </div>
                <div
                  class="wizard-footer-right"
                  :class="{ 'right-align': props.activeTabIndex > 0 }"
                >
                  <wizard-button
                    :disabled="props.activeTabIndex == 1"
                    @click.native="nextTab()"
                    class="next-btn"
                    :style="props.fillButtonStyle"
                  >
                    {{ $t("common.next") }}
                  </wizard-button>
                </div>
              </div>
              <div
                style="padding-top: 40px; margin-bottom: 40px"
                v-if="!allSitesHaveActiveSession"
              >
                <wizard-button
                  class="add-edit-wizard text-transform-uppercase"
                  :style="props.fillButtonStyle"
                  :disabled="
                    selectedSites.length == 0 ? true : submitted ? true : false
                  "
                  @click.native="onSubmit()"
                >
                  <!-- <i
                  class="bx bx-hourglass bx-spin font-size-16 align-middle mr-2 wizard-submit-button"
                  ></i> -->
                  {{ $t("emergencyList.form.startSessionButon") }}
                </wizard-button>
              </div>
            </div>
          </div>
        </form-wizard>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import DxTreeView from "devextreme-vue/tree-view";
import { FormWizard, TabContent, WizardButton } from "vue-form-wizard";

import moment from "moment";
const treeViewRef = "treeView";
const WizardRef = "wizard";

export default {
  name: "startSessionForm",
  components: {
    DxTreeView,
    FormWizard,
    TabContent,
    WizardButton,
  },
  data() {
    return {
      treeViewRef,
      WizardRef,
      showTypeTab: false,
      showSitesTab: false,
      selectedSites: [],
      selectedAreas: [],
      allSitesIds: [],
      allAreasIds: [],
      sitesOptions: [],
      type: null,
      allSitesHaveActiveSession: false,
      submitted: false,
      areasWithSession: {},
    };
  },
  computed: {
    ...mapGetters("emergency", ["getAreasWithSession"]),
    ...mapGetters("authfack", ["userDetails", "currentEntity"]),
    treeView() {
      return this.$refs[this.treeViewRef].instance;
    },
    // treeViewSelectionRemoved(){
    //   console.log('cc');
    //   return this.$refs[this.treeViewRef].unselectAll;
    // },
  },
  methods: {
    ...mapActions("emergency", ["startSession", "fetchAreasWithSession"]),
    onSubmit() {
      this.submitted = true;
      const { startSession, allSitesIds, allAreasIds, selectedSites, type } =
        this;
      let filteredAreaIds = selectedSites.filter(
        (id) => !allSitesIds.includes(id)
      );
      filteredAreaIds = filteredAreaIds.filter(
        (id) => !allAreasIds.includes(id)
      );

      // console.log('filteredAreaIds',filteredAreaIds);

      let formData = new FormData();
      for (var i = 0; i < filteredAreaIds.length; i++) {
        formData.append("areaIds[]", filteredAreaIds[i]);
      }
      formData.append("type", type);
      startSession(formData).then((data) => {
        document.getElementById("preloader").style.display = "block";
        document.getElementById("status").style.display = "block";
        console.log("ssssesh", data);
        this.$socket.emit("pingStartSessionDiffAdmin", {
          sessionId: data.data.id,
          sessionName: data.data.name,
          entity: this.currentEntity.id,
          user: this.userDetails,
        });
      });
    },
    treeViewSelectionChanged(e) {
      this.syncSelection(e.component);
      // console.log('this.selectedSites',this.selectedSites);
    },
    treeViewContentReady(e) {
      this.syncSelection(e.component);
    },
    syncSelection(treeView) {
      const selectedSites = treeView
        .getSelectedNodes()
        .map((node) => node.itemData.id);
      this.selectedSites = selectedSites;
      // console.log(this.selectedSites);
    },
    hideStartSessionModal() {
      this.removeAlignModalCenter();
      this.showSitesTab = false;
      if (this.$refs[this.treeViewRef]) {
        this.$refs[this.treeViewRef].instance.unselectAll();
        this.$refs[this.treeViewRef].instance.collapseAll();
      }
      // console.log('this.selectedSites',this.selectedSites);
    },
    showStartSessionModal() {
      this.addAlignModalCenter("alignModalCenter");
      this.showTypeTab = true;
      this.type = `Emergency (${moment(new Date()).format(
        "DD/MM/YYYY - hh:mm A"
      )})`;
      if (this.type) this.showSitesTab = true;
    },
    previousTab() {
      this.$refs[this.WizardRef].prevTab();
      this.addAlignModalCenter("alignModalCenter");
    },
    nextTab() {
      this.$refs[this.WizardRef].nextTab();
      this.removeAlignModalCenter();
    },
    addAlignModalCenter(className) {
      setTimeout(() => {
        let alignModalCenter = document.querySelector(
          "#startSessionModal___BV_modal_content_"
        );
        alignModalCenter.classList.add(className);
      }, 110);
    },
    removeAlignModalCenter() {
      setTimeout(() => {
        let alignModalCenter = document.querySelector(
          "#startSessionModal___BV_modal_content_"
        );
        alignModalCenter.classList.remove("alignModalCenter");
      }, 110);
    },
    addTransactionModalCenter() {
      setTimeout(() => {
        let transactionModalCenter = document.querySelector(
          "#startSessionModal___BV_modal_content_"
        );
        transactionModalCenter.classList.add("addTansaction");
      }, 110);
    },
  },
  beforeMount() {
    this.fetchAreasWithSession().then((data) => {
      this.areasWithSession = data.data;
      // console.log('this.areasWithSession', this.areasWithSession);
      if (this.areasWithSession && this.areasWithSession.allSiteHaveSession) {
        this.allSitesHaveActiveSession = true;
        this.addAlignModalCenter("alignAlertModalCenter");
      } else {
        this.addTransactionModalCenter();
        this.addAlignModalCenter("alignModalCenter");
      }

      this.areasWithSession && this.areasWithSession.data.length > 0
        ? this.areasWithSession.data.map((site) => {
            this.allSitesIds.push(site.id);

            if (site.have_session) {
              delete site.items;
            }

            this.sitesOptions.push({
              id: site.id,
              label: site.label,
              disabled: site.have_session ? true : false,
              isSite: true,
              items: site.items
                ? site.items.map((item) => {
                    if (item.have_session) this.allAreasIds.push(item.id);
                    return {
                      id: item.id,
                      label: item.label,
                      disabled: item.have_session ? true : false,
                      expanded: item.have_session ? true : false,
                      items: item.items
                        ? item.items.map((item2) => {
                            if (item2.have_session)
                              this.allAreasIds.push(item2.id);
                            return {
                              id: item2.id,
                              label: item2.label,
                              disabled: item2.have_session ? true : false,
                              expanded: item2.have_session ? true : false,
                              items: item2.items
                                ? item2.items.map((item3) => {
                                    if (item3.have_session)
                                      this.allAreasIds.push(item3.id);
                                    return {
                                      id: item3.id,
                                      label: item3.label,
                                      disabled: item3.have_session
                                        ? true
                                        : false,
                                      expanded: item3.have_session
                                        ? true
                                        : false,
                                      items: item3.items
                                        ? item3.items.map((item4) => {
                                            if (item4.have_session)
                                              this.allAreasIds.push(item4.id);
                                            return {
                                              id: item4.id,
                                              label: item4.label,
                                              disabled: item4.have_session
                                                ? true
                                                : false,
                                              expanded: item4.have_session
                                                ? true
                                                : false,
                                              items: item4.items
                                                ? item4.items.map((item5) => {
                                                    if (item5.have_session)
                                                      this.allAreasIds.push(
                                                        item5.id
                                                      );
                                                    return {
                                                      id: item5.id,
                                                      label: item5.label,
                                                      disabled:
                                                        item5.have_session
                                                          ? true
                                                          : false,
                                                      expanded:
                                                        item5.have_session
                                                          ? true
                                                          : false,
                                                      items: item5.items,
                                                    };
                                                  })
                                                : [],
                                            };
                                          })
                                        : [],
                                    };
                                  })
                                : [],
                            };
                          })
                        : [],
                    };
                  })
                : [],
            });
          })
        : [];
    });
  },
  created() {
    this.type = `Emergency (${moment(new Date()).format(
      "DD/MM/YYYY - hh:mm A"
    )})`;
  },
};
</script>

<style lang="scss">
:dir(ltr)
  div#startSessionModal___BV_modal_body_
  .wizard-card-footer
  .wizard-footer-left
  button {
  inset-inline-start: 140px !important;
}
:dir(rtl)
  div#startSessionModal___BV_modal_body_
  .wizard-card-footer
  .wizard-footer-left
  button {
  inset-inline-start: 120px !important;
}
:dir(rtl)
  div#startSessionModal
  .custom-form-wizard
  .wizard-card-footer
  .wizard-footer-right {
  inset-inline-end: 140px;
  top: -3.3px;
}
:dir(ltr)
  div#startSessionModal
  div#startSessionModal___BV_modal_content_
  div#startSessionModal___BV_modal_body_
  ul.wizard-nav.wizard-nav-pills {
  inset-inline-start: 50% !important;
}
:dir(rtl)
  div#startSessionModal
  div#startSessionModal___BV_modal_content_
  div#startSessionModal___BV_modal_body_
  ul.wizard-nav.wizard-nav-pills {
  inset-inline-start: 47% !important;
}
ul.dx-treeview-node-container.dx-treeview-node-container-opened
  li
  .d-flex.dx-template-wrapper.dx-item-content.dx-treeview-item-content {
  font-weight: 400 !important;
  font-size: 16px !important;
  line-height: 19px !important;

  color: #787878;
}
.dx-treeview-toggle-item-visibility.dx-treeview-toggle-item-visibility-opened::before {
  content: "\f002";
  font: 24px/24px DXIcons;
  color: #636161;
  top: 40%;
  margin-top: -12px;
  inset-inline-start: 50%;
}
.dx-treeview-toggle-item-visibility::before {
  content: "\f001";
  font: 24px/24px DXIcons;
  color: #636161;
  top: 45%;
  margin-top: -12px;
  inset-inline-start: 50%;
  left: unset;
  margin-left: unset;
  margin-inline-start: -12px;
}
.dx-treeview-node {
  padding-inline-start: 24px !important;
  padding-left: unset;
}
.dx-treeview-item-with-checkbox .dx-checkbox {
  left: unset;
  inset-inline-start: 35px;
}
.dx-checkbox-checked .dx-checkbox-icon::before,
.dx-checkbox-indeterminate .dx-checkbox-icon::before {
  inset-inline-start: 50% !important;
  margin-inline-start: -0.5em !important;
  left: unset;
  margin-left: unset;
}
.dx-scrollbar-vertical {
  right: unset;
  inset-inline-end: 0;
}
div#startSessionModal {
  div#startSessionModal___BV_modal_content_ {
    width: 500px;
    background: #ffffff;
    box-shadow: 0px 1px 40px 3px rgb(0 0 0 / 5%);
    border-radius: 26px;
    div#startSessionModal___BV_modal_body_ {
      padding: 0px !important;
      .inside-emergency-line {
        width: 420px;
        height: 1px;
        background: #ebebeb;
        margin: 40px auto 20px auto;
      }
      .actions-btn {
        width: 420px;
        margin: 0px auto 20px auto;
      }
      button.single-okay {
        background: #103f5e;
        width: 112px;
        height: 32px;
        border: none;
        color: #ffffff;
        border-radius: 16px;
        margin: auto;
        font-weight: 400;
        display: flex;
        align-items: 16px;
        font-size: 16px;
        justify-content: center;
        align-items: center;
        line-height: 19px;
      }
      .vue-form-wizard .wizard-card-footer {
        padding: 0 !important;
        margin: auto;
        width: 416px;
      }
      .back-next-dots {
        margin-top: 40px;
      }
      .wizard-card-footer .wizard-footer-left {
        -webkit-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
        position: relative;
      }
      button.wizard-btn.back-btn {
        background: transparent !important;
      }
      button.wizard-btn.next-btn {
        color: #103f5e !important;
      }
      .wizard-card-footer .wizard-footer-right {
        -webkit-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
        position: relative;
      }
      .wizard-card-footer .wizard-footer-left button {
        float: inline-start;
        position: relative;
        min-width: 36px;
        color: #103f5e !important;
      }

      button.wizard-btn.add-edit-wizard {
        text-align: center;
        letter-spacing: 0.25px;
        width: 416px;
        height: 44px;
        border: none;
        font-weight: 700;
        font-size: 16px;
        line-height: 17px;
        color: #fff;
        border-radius: 22px;
        margin: 0 !important;
        padding: 0 !important;
      }
      button.wizard-btn.add-edit-wizard:disabled {
        opacity: 1 !important;
        background: #9fb2bf !important;
        cursor: not-allowed;
      }
      button.wizard-btn.next-btn {
        position: relative;
        inset-inline-end: 0px !important;
        float: inline-end;
        min-width: 36px;
        background: transparent !important;
        border: none !important;
      }
      ul.wizard-nav.wizard-nav-pills {
        -ms-flex-wrap: nowrap !important;
        flex-wrap: nowrap !important;
        position: absolute !important;
        -webkit-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
        bottom: -42px !important;
        margin-bottom: 0 !important;
      }
      .vue-form-wizard .wizard-tab-content {
        min-height: 0px !important;
      }
      .custom-form-wizard .wizard-nav li {
        margin-inline-end: 6px;
        margin-top: 0;
      }
      .wizard-btn.back-btn:disabled,
      div#add-edit-user
        div#add-edit-user___BV_modal_content_
        div#add-edit-user___BV_modal_body_
        .wizard-btn.next-btn:disabled {
        color: #103f5e !important;
        cursor: not-allowed;
        opacity: 0.4 !important;
      }
      .emergency-input {
        width: 416px;
        margin-inline-end: auto;
        margin-inline-start: auto;
      }
      .dx-state-disabled.dx-item.dx-treeview-item
        .d-flex.dx-template-wrapper.dx-item-content.dx-treeview-item-content
        span.disabled-area {
        padding-inline-start: 0px !important;
      }
      .dx-state-disabled.dx-item.dx-treeview-item
        .d-flex.dx-template-wrapper.dx-item-content.dx-treeview-item-content
        span {
        padding-inline-start: 0px !important;
      }
      .d-flex.dx-template-wrapper.dx-item-content.dx-treeview-item-content {
        height: 17px;
      }
      .aletClosingMsg {
        margin-top: 22px;
        margin-inline-end: 22px;
      }
      .modal-details {
        .title-con {
          .modal-title-head {
            font-weight: 700;
            font-size: 16px;
            line-height: 20px;
            margin: 40px 146px 40px auto;
            color: #000000;

            svg {
              position: relative;
              inset-inline-start: 155px;
            }

            p {
              font-weight: 700;
              font-size: 17px;
              line-height: 20px;
              margin-bottom: 0px !important;
            }
          }
        }

        .dx-checkbox-icon {
          width: 17px;
          height: 17px;
          border: 3px solid #103f5e !important;

          border-radius: 3px;
        }

        .dx-treeview-select-all-item .dx-checkbox-text {
          padding-inline-start: 16px;

          font-weight: 700;
          font-size: 16px;
          line-height: 19px;

          color: #787878;
        }
        div#treeview {
          .dx-scrollable-wrapper {
            width: 420px;
          }
          .dx-widget.dx-checkbox.dx-checkbox-has-text.dx-treeview-select-all-item {
            border: none;
          }
          .dx-treeview-select-all-item {
            padding: 0px !important;
            margin-bottom: 8px;
          }
          .d-flex.dx-template-wrapper.dx-item-content.dx-treeview-item-content {
            font-weight: 700;
            font-size: 16px;

            line-height: 19px;
            color: #787878;
          }
          .dx-treeview-item {
            padding-top: 24px !important;
            padding-inline-end: 0 !important;
            padding-bottom: 24px !important;
            padding-inline-start: 40px !important;
          }
          .dx-checkbox-container {
            padding-top: 11px;
          }
          .dx-checkbox-checked .dx-checkbox-icon,
          .dx-checkbox-indeterminate .dx-checkbox-icon {
            background: #103f5e !important;
            border: none !important;
          }
          .dx-checkbox-checked .dx-checkbox-icon {
            border: solid 3px #103f5e !important;
          }
        }
      }
    }
  }

  div.modal-title-head-sites-have-session {
    margin: 40px auto 40px auto;

    font-weight: 700;
    font-size: 16px;
    line-height: 20px;
    text-align: center;
    color: #000000;
    p {
      margin-bottom: 0px !important;
    }
  }

  .form-control {
    background-color: #f2f2f2;
    border-color: #f2f2f2;
  }

  .warningMsg {
    color: #4a4a4a;
    font-weight: 400 !important;
    font-size: 16px !important;
    line-height: 26px !important;
    text-align: center;
    width: 420px !important;
    margin: 0px auto 0px auto;
  }

  .closeStartSessionModal {
    margin-top: 32px;
    margin-inline-end: 32px;
    cursor: pointer;
  }
  .dx-treeview-toggle-item-visibility::before {
    inset-inline-start: 20% !important;
    top: 50% !important;
  }
  .dx-checkbox-icon {
    top: 0px !important;
  }
  dx-treeview-item {
    display: block;
    cursor: pointer;
    padding: 13px 8px;
    min-height: 65px !important;
    line-height: 22px;
  }
  .dx-treeview-toggle-item-visibility {
    height: 65px;
    left: unset;
    inset-inline-start: 0;
  }
  .dx-state-disabled.dx-item.dx-treeview-item {
    .d-flex.dx-template-wrapper.dx-item-content.dx-treeview-item-content {
      span.disabled-area {
        font-weight: 400;
        font-size: 16px;
        line-height: 19px;

        color: #787878;

        opacity: 0.4;
      }
      span {
        padding-inline-start: 32px;
      }
    }
    .area-have-session {
      font-weight: 500;
      font-size: 14px;
      line-height: 17px;
      color: #34c38f;
      margin-inline-start: 15px;
    }
  }

  .action-btns {
    .start-session-btn {
      width: 416px;
      margin-top: 40px;
      margin-bottom: 40px;
      border-radius: 22px;
      background-color: #103f5e;
      font-weight: 700;
      font-size: 16px;
      line-height: 17px;
      color: #ffffff;
      height: 44px;
    }
    .start-session-btn:disabled {
      cursor: not-allowed;
      background-color: #9fb2bf;
      border: none;
      opacity: 1;
    }

    .start-btn {
      background: #103f5e;
      border-radius: 16.6275px;
      width: 111px;
      height: 33px;
      color: #ffffff;

      font-weight: 400;
      font-size: 16px;
      line-height: 15px;
      text-align: center;
      margin-inline-end: 31px;
    }
  }

  .width-40 {
    width: 40%;
  }

  .dx-field-label {
    height: 100vh !important;
  }

  .custom-form-wizard {
    padding: 0;
    position: relative;
    .wizard-progress-with-circle {
      display: none;
    }

    .wizard-navigation {
      position: relative;
      bottom: 0;
    }

    .wizard-nav {
      position: absolute !important;
      inset-inline-start: 52%;
      transform: translate(-50%, -50%);
      bottom: -55px;
      margin-bottom: 0 !important;
      li {
        margin-inline-end: 15px;
        margin-top: 0;
        a {
          .wizard-icon-circle {
            height: 7px;
            width: 7px;
            border: 1px solid #c7c7c7 !important;
            background-color: #c7c7c7 !important;

            .wizard-icon-container {
              .wizard-icon {
                display: none !important;
              }
            }
            .wizard-icon {
              display: none !important;
            }
          }
        }
      }
    }
    .dx-treeview-item.dx-state-disabled {
      opacity: 1;
    }
    .wizard-tab-content,
    .wizard-card-footer {
      padding: 0 !important;
    }
    .wizard-card-footer {
      .wizard-footer-left,
      .wizard-footer-right {
        transform: translate(-50%, -50%);
      }
      .wizard-footer-left button:disabled,
      .wizard-footer-right button:disabled {
        font-weight: 700 !important;
        font-size: 16px !important;
        line-height: 17px !important;
        letter-spacing: 0.25px;
        color: rgba(96, 96, 96, 0.87) !important;
        opacity: 0.2 !important;
      }
      .wizard-footer-left {
        button {
          float: inline-start;
          position: relative;
          top: -3px;
          inset-inline-start: 165px;
          background: none;
          border: none;
          padding: 0;
          font-weight: 700;
          font-size: 16px;
          line-height: 17px;
          letter-spacing: 0.25px;
          color: #103f5e;
          margin-bottom: 0;
          min-width: 50px;
        }
      }

      .wizard-footer-right {
        position: absolute;
        inset-inline-end: 115px;
        top: -5px;
        button {
          background: none;
          border: none;
          padding: 0;
          font-weight: 700;
          font-size: 16px;
          line-height: 17px;
          letter-spacing: 0.25px;
          color: #103f5e;
          margin-bottom: 0;
          min-width: 50px;
        }
      }
    }

    .emergency-type {
      width: 416px;
      margin: auto;
      margin-bottom: 48px;
    }

    .sitesTreeview {
      margin-inline-end: 40px;
      margin-inline-start: 40px;
    }

    .sites-text-header {
      font-weight: 700;
      font-size: 16px;
      line-height: 19px;
      color: #787878;
      margin-bottom: 21px;
    }

    // in disabled state
    .dx-widget.dx-checkbox.dx-state-disabled {
      background-color: transparent !important;
    }
    .dx-checkbox.dx-checkbox-checked.dx-state-disabled .dx-checkbox-icon,
    .dx-checkbox.dx-checkbox-checked.dx-state-readonly .dx-checkbox-icon,
    .dx-checkbox.dx-checkbox-indeterminate.dx-state-disabled .dx-checkbox-icon,
    .dx-checkbox.dx-checkbox-indeterminate.dx-state-readonly .dx-checkbox-icon {
      background-color: transparent !important;
      color: transparent !important  ;
    }
    .dx-widget.dx-checkbox.dx-checkbox-checked.dx-state-disabled {
      .dx-checkbox-container {
        span.dx-checkbox-icon::before {
          border: solid #9f9f9f 3px !important;
          width: 17px !important;
          background-color: #ffffff !important;
          height: 17px !important;
          border-radius: 3px !important;
        }
      }
    }
    .dx-treeview-item-with-checkbox .dx-treeview-item {
      border-bottom: 1px solid #ebebeb !important;
    }
  }
  .addTansaction {
    transition: all 0.3s ease;
  }

  .alignModalCenter {
    margin-top: 130px;
  }

  .alignAlertModalCenter {
    margin-top: 240px;
  }
}
</style>
